import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ChangePasswordData,
  loginResponse,
  ResetPasswordData,
  ResetPasswordDataFetch,
} from 'api/adminApi';
import instance, { AsyncThunkConfig, ApiError } from 'api/axiosConfig';
import { isAxiosError } from 'axios';
import {
  adminChangePasswordURL,
  adminResetPasswordConfirmURL,
  adminResetPasswordURL,
  adminURL,
} from 'utils/paths';

export const fetchAdminLogin = createAsyncThunk<
  loginResponse | undefined,
  FormData,
  AsyncThunkConfig
>('admin/login', async (bodyFormData, thunkApi) => {
  try {
    const response = await instance.post<loginResponse>(adminURL, bodyFormData);

    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response != null) {
      const extractedError = error.response.data as ApiError;

      return thunkApi.rejectWithValue(extractedError);
    }
    throw error;
  }
});

export const fetchChangePassword = createAsyncThunk<
  undefined,
  ChangePasswordData,
  AsyncThunkConfig
>('admin/change-password', async ({ ...data }, thunkApi) => {
  try {
    await instance.post(
      adminChangePasswordURL,
      {
        oldPassword: data.oldPassword,
        newPassword: data.newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${data?.tokenAccess ?? ''}`,
        },
      }
    );
  } catch (error) {
    if (isAxiosError(error) && error.response != null) {
      const extractedError = error.response.data as ApiError;
      return thunkApi.rejectWithValue(extractedError);
    }
    throw error;
  }
});

export const fetchResetPassword = createAsyncThunk<
  undefined,
  ResetPasswordData,
  AsyncThunkConfig
>('admin/reset-password', async ({ ...data }, thunkApi) => {
  try {
    await instance.post(adminResetPasswordURL, {
      email: data.value,
    });
  } catch (error) {
    if (isAxiosError(error) && error.response != null) {
      const extractedError = error.response.data as ApiError;
      return thunkApi.rejectWithValue(extractedError);
    }
    throw error;
  }
});

export const fetchResetPasswordConfirm = createAsyncThunk<
  undefined,
  ResetPasswordDataFetch,
  AsyncThunkConfig
>('admin/reset-password-confirm', async (data, thunkApi) => {
  try {
    await instance.post(adminResetPasswordConfirmURL, {
      newPassword: data.value,
      user: data.user,
      token: data.token,
    });
  } catch (error) {
    if (isAxiosError(error) && error.response != null) {
      const extractedError = error.response.data as ApiError;
      return thunkApi.rejectWithValue(extractedError);
    }
    throw error;
  }
});
